import React from 'react';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

import Icon from 'components/utils/icon';
import styles from 'components/table/appTable.module.scss';
import { PortalsSearchProps } from './PortalsSearch.types';

export const PortalsSearch = ({ value, onChange }: PortalsSearchProps) => (
  <div className={styles.externalHandlers}>
    <div className={styles.searchBox}>
      <input
        type="text"
        className="form-control"
        placeholder="Search"
        aria-label="Search"
        value={value}
        onChange={e => onChange(e.target.value)}
      />
      <Icon icon={faSearch} />
    </div>
  </div>
);
